import { BreakingBanner } from "#/components/dashboard/BreakingBanner.js";
import { WhatsNewBanner } from "#/components/dashboard/WhatsNewBanner.js";
import { TemplateRouter } from "#/components/templates/TemplateRouter.js";
import { createT } from "#/lib/i18n.js";
import type { IndexPageProps } from "#/lib/templates/types.js";

export { Page };

function Page(props: IndexPageProps) {
  const { outbreak, ticker, changes, locale } = props;
  const t = createT(locale, "landing");

  return (
    <>
      <WhatsNewBanner changes={changes ?? { count: 0, items: [] }} locale={locale} t={t} />
      <BreakingBanner outbreak={outbreak} ticker={ticker} locale={locale} t={t} />
      <TemplateRouter {...props} />
    </>
  );
}
